// @flow
import { Table } from 'semantic-ui-react';
import React from 'react';

import { StyledTable } from '../../common-utils/styledComponents';

const StaticTableHeaderRow = ({ cells }) => (
  <Table.Row>
    {cells.map((cell, index) => (
      <Table.HeaderCell key={index}> {cell} </Table.HeaderCell>
    ))}
  </Table.Row>
);

const StaticTableDataRow = ({ cells, cellRenderers, rowIndex }) => {
  const renderCell = (cell, colIndex) => {
    // If a renderer exists for this column, use it; otherwise render the cell as-is
    if (cellRenderers && Array.isArray(cellRenderers) && cellRenderers[colIndex]) {
      const renderer = cellRenderers[colIndex];
      return renderer(cell, rowIndex, colIndex, cells);
    }
    return cell;
  };

  return (
    <Table.Row>
      {cells.map((cell, index) => (
        <Table.Cell key={index}> {renderCell(cell, index)} </Table.Cell>
      ))}
    </Table.Row>
  );
};

export const StaticTable = ({ tableContents, cellRenderers = null }) => {
  const headerRow = tableContents.headerRow;
  return (
    <StyledTable
      celled={true}
      columns={headerRow.length}
      compact={true}
      padded="very"
      textAlign="left"
      verticalAlign="middle"
    >
      <Table.Header>
        <StaticTableHeaderRow cells={headerRow} />
      </Table.Header>
      <Table.Body>
        {tableContents.dataRows.map((dataRow, index) => (
          <StaticTableDataRow
            cellRenderers={cellRenderers}
            cells={dataRow}
            key={index}
            rowIndex={index}
          />
        ))}
      </Table.Body>
    </StyledTable>
  );
};
